module.exports = __webpack_public_path__ + "img/fruits.7b06b272.png";